export default __webpack_public_path__ + "static/media/planet-mars.4da82092.jpg";